import { CONTEXT } from '../config/consts/commons';

import { COUNTRIES_REGIONAL_CONFIG } from '@wareclouds/frontend-common';

function formatCurrency({ amount, minimumFractionDigits = 0 }) {
  const { countryCode, currency } = COUNTRIES_REGIONAL_CONFIG[CONTEXT];

  return new Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(amount);
}

export default formatCurrency;
